import { render, staticRenderFns } from "./gl-avatar.vue?vue&type=template&id=baa8063c"
import script from "./gl-avatar.vue?vue&type=script&lang=js"
export * from "./gl-avatar.vue?vue&type=script&lang=js"
import style0 from "./gl-avatar.vue?vue&type=style&index=0&id=baa8063c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports